import React from "react";
import { TextField, MenuItem, InputAdornment } from "@mui/material";
import { CalendarMonth as CalendarIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const DateFormatSelect = ({ value, onChange }) => {
  const { t } = useTranslation("settings");

  const options = [
    { label: "YYYY-MM-DD", value: "YYYY-MM-DD" },
    { label: "DD/MM/YYYY", value: "DD/MM/YYYY" },
    { label: "MM/DD/YYYY", value: "MM/DD/YYYY" },
    { label: "DD MMM YYYY", value: "DD MMM YYYY" },
  ];

  return (
    <TextField
      select
      label={t("dateFormat")}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      variant="outlined"
      size="small"
      sx={{
        minWidth: 200, // Lite bredare för att rymma formaten snyggt
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <CalendarIcon fontSize="small" color="action" />
          </InputAdornment>
        ),
      }}
    >
      {options.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default DateFormatSelect;
